module.exports = __webpack_public_path__ + "uy.94e576aa509ef694ad62.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/1x1/uy.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/1x1/uy.svg
// module chunks = 0